import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {CardStoreService} from '../../shared/card-store.service';
import {CardDeck} from '../../shared/card-deck';
import {Observable} from 'rxjs';
import {AttributionService} from '../shared/attribution.service';
import {AttributionType} from '../shared/attribution-types.enum';
import {RecommendedGameDesign} from '../../design-recommender/shared/recommended-game-design';
import {RecommendationService} from '../../design-recommender/shared/recommendation.service';
import {GameDesignService} from '../../design-recommender/shared/game-design.service';
import {GameDesign} from '../../design-recommender/shared/game-design';
import {UserValidation} from '../../shared/user-validation';

@Component({
  selector: 'em-carddeck',
  templateUrl: './carddeck.component.html',
  styleUrls: ['./carddeck.component.css']
})
/**
 * Component to show the different carddecks.
 *
 * Gets the id of the carddeck from the routing variable cardeckid on
 * the ngOnInit methode and initializes the cardDeck$ Observable with the
 * corresponding carddeck.
 */
export class CarddeckComponent implements OnInit {
  cardDeck$: Observable<CardDeck>;

  recommendedGameDesign: RecommendedGameDesign;
  gameDesign: GameDesign;

  userValidation$: Observable<UserValidation>;

  attribution: AttributionType;
  subAttribution: AttributionType;
  recommendationSorting: boolean;

  constructor(
    private cs: CardStoreService,
    private rs: RecommendationService,
    private gs: GameDesignService,
    private route: ActivatedRoute,
    private as: AttributionService
  ) {
    this.cs.getUserLoginListener().subscribe( b => {
      if (b === undefined) {
        this.recommendedGameDesign = undefined;
        this.gameDesign = undefined;
        this.cardDeck$ = undefined;
        this.userValidation$ = undefined;
      }
    });
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(
      paramMap => {
        const cardDeckId = Number(paramMap.get('carddeckid'));
        this.cardDeck$ = this.cs.getCardDeck(cardDeckId);
        this.cardDeck$.subscribe(deck => {
          this.gs.initGameDesign(deck.id, deck.type);

          this.gameDesign = this.gs.getGameDesign();
          this.gs.getGameDesignBehaviorSubject().subscribe(gameDesign => {
            this.gameDesign = gameDesign;
          });

          // Changes in the game design should cause new recommendations
          if (!this.rs.checkIfRecommendationRequestIsPossible()) {
            this.rs.setGameDesignBehaviorSubject(this.gs.getGameDesignBehaviorSubject());
          }

          // Changes in the recommendation should change the recommended game design
          this.rs.getRecommendationBehaviorSubject().subscribe(recommendedGameDesign => {
            if (this.rs.hasRecommendation()) {
              this.recommendedGameDesign = recommendedGameDesign;
            }else{
              this.recommendedGameDesign = null;
            }
          });

          this.rs.getRecommendationSortingBehaviorSubject().subscribe(sort => {
            this.recommendationSorting = sort;
          });
        });
      }
    );
    this.as.getAttributionBehaviorSubject().subscribe(
      attributionType => {
        this.attribution = attributionType;
      }
    );
    this.as.getSubAttributionBehaviorSubject().subscribe(
      attributionType => {
        this.subAttribution = attributionType;
      }
    );
    this.cs.getUserLoginListener().subscribe(b => {
      this.userValidation$ = b;
    });
    // Ensure that the GameDesign is initizalized with ALL cardDecks
    // and not only with the one derived from the routing param
    this.userValidation$.subscribe( userValidation => {
      for (const cardDeck of userValidation.carddecks) {
        this.gs.initGameDesign(cardDeck.id, cardDeck.type);
      }
    });
  }
}
